/**
 * @generated SignedSource<<e292b51624ee52bb62b675fcbf9db5db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceFieldInteractionType = "AI_SUGGESTION" | "EDITABLE" | "VIEW_ONLY";
export type SalesforceSelectedRecordForAiSuggestions = {
  fields: ReadonlyArray<SalesforceFieldDataInput>;
  objectLabel: string;
  objectName: string;
  recordId: string;
  recordName: string;
};
export type SalesforceFieldDataInput = {
  interactionType: SalesforceFieldInteractionType;
  label: string;
  length?: number | null;
  name: string;
  type: string;
  value?: string | null;
};
export type SalesforceGetAiSuggestionsQuery$variables = {
  noteId: string;
  selectedRecords: ReadonlyArray<SalesforceSelectedRecordForAiSuggestions>;
};
export type SalesforceGetAiSuggestionsQuery$data = {
  readonly salesforceGetAiSuggestions: {
    readonly suggestions: ReadonlyArray<{
      readonly fields: ReadonlyArray<{
        readonly fieldLabel: string;
        readonly suggestedValue: string;
      }>;
      readonly objectLabel: string;
      readonly recordId: string;
    }>;
  };
};
export type SalesforceGetAiSuggestionsQuery = {
  response: SalesforceGetAiSuggestionsQuery$data;
  variables: SalesforceGetAiSuggestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedRecords"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "selectedRecords",
        "variableName": "selectedRecords"
      }
    ],
    "concreteType": "SalesforceAiSuggestionsResult",
    "kind": "LinkedField",
    "name": "salesforceGetAiSuggestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesforceAiSuggestionObject",
        "kind": "LinkedField",
        "name": "suggestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "objectLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recordId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesforceAiSuggestionField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suggestedValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceGetAiSuggestionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceGetAiSuggestionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f61c19d768ebe1e29a2c51b322be9c3f",
    "id": null,
    "metadata": {},
    "name": "SalesforceGetAiSuggestionsQuery",
    "operationKind": "query",
    "text": "query SalesforceGetAiSuggestionsQuery(\n  $noteId: String!\n  $selectedRecords: [SalesforceSelectedRecordForAiSuggestions!]!\n) {\n  salesforceGetAiSuggestions(noteId: $noteId, selectedRecords: $selectedRecords) {\n    suggestions {\n      objectLabel\n      recordId\n      fields {\n        fieldLabel\n        suggestedValue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b32a9fbb843609a9715ec40f755d7f65";

export default node;
